module.exports = __webpack_public_path__ + "static/media/01_In-Transit-ontime.2180fabc.jpg";